import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { fundPage } from '@/content/engagement';
import { assetUrl } from '@/lib/asset-url';
import { TDC_HOME_URL } from '@/lib/external-links';

const TDC_PRIMARY_LOGO = 'brand/tdc-logo-primary.png';

export function FundHero() {
  return (
    <header className="relative overflow-hidden px-4 pt-12 pb-14 sm:px-6 sm:pt-16 sm:pb-16 lg:px-8">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-cta/10 opacity-90"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          backgroundImage:
            'radial-gradient(circle at 16% 18%, color-mix(in oklab, var(--primary) 16%, transparent), transparent 40%), radial-gradient(circle at 84% 14%, color-mix(in oklab, var(--cta) 14%, transparent), transparent 34%)'
        }}
      />

      <div className="relative z-10 mx-auto grid w-full max-w-7xl items-center gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(18rem,28rem)] lg:gap-16">
        <div className="min-w-0">
          <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
            {fundPage.eyebrow}
          </p>
          <h1 className="font-display text-foreground max-w-3xl text-4xl font-semibold tracking-tight text-balance sm:text-5xl md:text-6xl">
            {fundPage.title}
          </h1>
          <p className="text-muted-foreground mt-5 max-w-3xl text-base leading-relaxed sm:text-lg">
            {fundPage.lead}
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <Button asChild size="lg" variant="cta" className="sm:min-w-48">
              <Link to="/donate">Donate to NextOnVera</Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="sm:min-w-48">
              <Link to="/get-involved#partner">Start a multi-year gift</Link>
            </Button>
            <Button asChild size="lg" variant="link" className="text-primary justify-start px-0 sm:px-3">
              <Link to="/get-involved#advocate">Support advocacy</Link>
            </Button>
          </div>
        </div>

        <a
          href={TDC_HOME_URL}
          target="_blank"
          rel="noreferrer noopener"
          className="focus-visible:ring-ring mx-auto flex w-full max-w-[15rem] items-center justify-center rounded-xl p-3 sm:p-4"
          style={{
            backgroundImage:
              "linear-gradient(160deg, #f5e6d3 0%, #e6c9a2 28%, #bd8f58 50%, #96682f 55%, #d6ab6e 72%, #f0dcc2 100%)",
            boxShadow:
              "0 18px 32px -14px rgba(72, 45, 15, 0.5), 0 6px 12px -6px rgba(72, 45, 15, 0.35), 0 1px 2px rgba(72, 45, 15, 0.25), inset 0 2px 0 rgba(255, 244, 228, 0.95), inset 0 -3px 6px rgba(72, 45, 15, 0.28), inset 2px 0 4px rgba(255, 240, 218, 0.6), inset -2px 0 4px rgba(72, 45, 15, 0.16)",
            border: "1px solid rgba(122, 84, 42, 0.55)",
            transform: "perspective(1200px) rotateX(2.5deg)",
          }}
        >
          <img
            src={assetUrl(TDC_PRIMARY_LOGO)}
            alt="Tour De Cure"
            className="h-auto w-full object-contain object-center drop-shadow-[0_6px_12px_rgba(72,45,15,0.3)]"
            decoding="async"
          />
          <span className="sr-only">(opens in new tab)</span>
        </a>
      </div>
    </header>
  );
}
